import React from 'react';
import {Instagram, Phone, Mail, MapPin} from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-black text-white py-8 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <a href="#" className="flex items-center space-x-4">
              <img 
                src="https://lh3.googleusercontent.com/d/1Qgq7h63yR7ue7w9yQyEtPdaeVkhGgdm8" 
                alt="Aeromaps Bahia Logo" 
                className="h-16 w-auto"
              />
              <div className="flex flex-col">
                <span className="text-2xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-white tracking-tight transition-all duration-300 hover:from-blue-400 hover:to-gray-200 hover:scale-105">AEROMAPS BAHIA</span>
                <span className="text-sm text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-white tracking-widest font-light transition-all duration-300 hover:from-blue-400 hover:to-gray-200">Imaging Solutions</span>
                <p className="text-gray-500 text-xs mt-1">© {new Date().getFullYear()} Todos os direitos reservados.</p>
              </div>
            </a>
          </div>
          <div className="flex flex-col items-center md:items-end space-y-3">
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/aeromapsbahia" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-500 transition-colors duration-300">
                <Instagram size={24} />
              </a>
              <a href="https://wa.me/5571991717353" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-500 transition-colors duration-300">
                <Phone size={24} />
              </a>
              <a href="mailto:contato@aeromaps.com.br" className="text-gray-400 hover:text-blue-500 transition-colors duration-300">
                <Mail size={24} />
              </a>
              <a href="https://maps.google.com/?q=Salvador,BA" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-500 transition-colors duration-300">
                <MapPin size={24} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
